import { DataLayerAdapter } from './datalayer/data-layer-adapter';
export class NoOperationTrackingService {
    featureAppId;
    constructor(appId) {
        this.featureAppId = appId;
    }
    featureAppName;
    evaluateLinkType(targetUrl) {
        return undefined;
    }
    getDatalayer() {
        return DataLayerAdapter.getInstance().getDataLayer();
    }
    registerImpressionTracking(element, createDefaultImpressionEvent, furtherImpressions) {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-empty-function
        return () => { };
    }
    sanitizeUrl(url) {
        return '';
    }
    track(event) { }
    trackInternalNavigation(event, href) { }
    unbind() { }
    updateComponent(componentUpdate) { }
    updateUser(userUpdate) { }
}
